/**
 * **La borne d'un jour « déjà vécu », côté écran** (décision PO D30 du
 * 2026-09-23, Matériel ; rangée hors de tout module métier, D116 — c'est son SEUL
 * chemin).
 *
 * ═════════════════════════════════════════════════════════════════════════════
 * CE QUE CE MODULE RÉPARE
 * ═════════════════════════════════════════════════════════════════════════════
 * Un passage de vérification ne se date pas dans le futur. Le serveur le refuse
 * au jour de l'ORGANISME (`tenant_config.timezone`, `_jour_de_l_organisme`),
 * depuis D30. Le sélecteur de date, lui, grisait tout ce qui suit le jour du
 * NAVIGATEUR (`maxDate={new Date()}`) : un poste réglé en UTC, à 23 h 30, pour
 * un organisme à Paris (déjà le lendemain), ou un organisme à La Réunion lu
 * depuis la métropole, ne pouvait PAS choisir « aujourd'hui » — le jour même
 * que le serveur accepte.
 *
 * ⚠️ **Le navigateur ne connaît pas le fuseau de l'organisme** : aucune route
 * ne le lui sert. La borne exacte reste donc au serveur, qui refuse avec
 * `CONTROL_DATE_IN_FUTURE`. Ici, on grise seulement ce qu'AUCUN organisme ne
 * peut avoir déjà vécu : les jours postérieurs au jour de UTC+14, le fuseau le
 * plus avancé du globe (Kiribati). C'est le MÊME filet que le validateur du
 * domaine (`resource_controls._pas_dans_le_futur`, `_maintenant() + 14 h`) :
 * jamais un jour que le serveur accepte n'est grisé, et « après-demain » l'est
 * toujours.
 *
 * ⚠️ **Calculé sur l'INSTANT, jamais sur le fuseau du navigateur** : le jour de
 * UTC+14 se lit sur les champs UTC de `maintenant + 14 h`. Il est rendu en
 * minuit LOCAL, la forme qu'attend le calendrier (il compare des jours).
 */

/** Quatorze heures : l'avance de UTC+14 sur UTC. */
const AVANCE_MAXIMALE_MS = 14 * 60 * 60 * 1000

/** Le dernier jour qu'un organisme, où qu'il soit, peut avoir déjà vécu — en
 *  minuit local, pour `maxDate`. */
export function leJourLePlusAvanceDuGlobe(maintenant: Date = new Date()): Date {
    const ailleurs = new Date(maintenant.getTime() + AVANCE_MAXIMALE_MS)
    return new Date(ailleurs.getUTCFullYear(), ailleurs.getUTCMonth(), ailleurs.getUTCDate())
}
